import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getCourseFlashCardList = (courseId) =>
  httpClient.get(`${apis.GET_COURSE_FLASH_CARD_LIST}/${courseId}`);
